import React from "react";

export function WBishopIcon({ color = "#3C3C3C" }: { color?: string }) {
  return (
    <svg
      height="1em"
      width="1em"
      viewBox="0 0 24 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9628 1C10.2896 1 9 2.07814 9 3L10 5C-2.75113 16.9824 5.60549 28 5.60549 28H18.3209C18.3209 28 23.9948 21.2169 19 12L16.5516 15.5133C16.0193 16.4351 14.9929 16.7804 14.25 16.288C13.5072 15.7965 13.3388 14.6578 13.8711 13.7367L17 9C16.0318 7.75209 15.1432 6.06485 14 5L15 3C15 2.07729 13.6351 1 11.9628 1Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 26C12 26 4.64345 26.0423 2.57991 27.4277C1.18838 28.3618 0.85963 30.6443 1.04898 33H22.951C23.1403 30.6452 22.8124 28.3609 21.42 27.4268C19.3573 26.0432 12 26 12 26Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  );
}
